import * as types from './mutation-types'

export const getShopBox = ({ commit }) => {
  return new Promise((resolve, reject) => {
    window.axios.get('pos/get/shopBox').then((response) => {
      commit(types.UPDATE_SHOP_BOX, response.data.shopBox)
      commit(types.ADD_BOXES, response.data.boxes)
      resolve(response)
    }).catch(reject)
  })
}

export const getSession = ({ commit, dispatch, state }) => {
  return new Promise((resolve, reject) => {
    window.axios.get('pos/get/session').then((response) => {
      commit(types.UPDATE_SESSION, response.data.session)
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}

export const openSession = ({ commit, dispatch, state }, data) => {
  return new Promise((resolve, reject) => {
    window.axios.post('pos/open/session', data).then((response) => {
      commit(types.UPDATE_SESSION, response.data.session)
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}

export const closeSession = ({ commit, dispatch, state }) => {
  return new Promise((resolve, reject) => {
    window.axios.post('pos/close/session').then((response) => {
      commit(types.UPDATE_SESSION, response.data.session)
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}


export const getSingleSession = ({ commit, dispatch, state }, id) => {
  return new Promise((resolve, reject) => {
    window.axios.get(`pos/get/${id}/session`).then((response) => {
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}


export const normalizationInvoice = ({commit, dispatch, state}, id) => {
  return new Promise((resolve, eject) => {
    window.axios.get('generate-invoice-normalized/' + id).then((response) => {
      resolve(response)
    }).catch((err) => {
      eject(err)
    })
  })
}

export const verifyInvoiceNormalization = ({commit, dispatch, state}, id) => {
  return new Promise((resolve, eject) => {
    window.axios.get('verify-invoice-normalized/' + id).then((response) => {
      resolve(response)
    }).catch((err) => {
      eject(err)
    })
  })
}

export const verifyInvoiceCountryBeninConfig = ({commit, dispatch, state}) => {
  return new Promise((resolve, eject) => {
    window.axios.get('verify-country-invoice-configuration').then((response) => {
      resolve(response)
    }).catch((err) => {
      eject(err)
    })
  })
}
